// import React from "react";
// import { Row, Col } from 'react-bootstrap';
// import CustomCheckboxTree from 'components/CheckboxTree/CheckboxTree';
// import { useState, useEffect } from "react";
// import { FetchAPI } from '../../api/fetch';
// import Cookies from 'universal-cookie';
// const cookies = new Cookies();

// function Step2(props) { 
//   let [nodeValue, setnodeValue] = useState(props.block.nodes);
//   useEffect(() => {
//     (async () => {
//       // if(props.futurename === 'Role'){
//         let getURL = props.dropDwnApi;
//         const getdrpdwnresponse = await FetchAPI(getURL);
//         const getdrpdwnresponseJson = await getdrpdwnresponse.json();
//         setnodeValue(getdrpdwnresponseJson.data.modules);
//       // }
//     })()
//   }, []);

//   if (props.currentStep !== props.block.step) {
//     return null
//   }
//   return(
//   <div>
//     <Row>
//       <Col md="4" className="mb-3">
//         <div className="custom-control custom-checkbox pl-3">
//           <CustomCheckboxTree
//             nodes={nodeValue}
//             checked = {chk => props.checkboxcheck(chk)}
//             expanded = {exp => props.checkboxexpand(exp)}
//             selectChildValueCheckbox={props.selectChildValueCheckbox}
//             selectChildValueCheckboxExpanded={props.selectChildValueCheckboxExpanded}
//           />
//               <span>{ (Object.keys(props.selectChildValueCheckbox).length == 0) ? 
//                                props.validator.message('Minimum one Permission', props.selectChildValueCheckbox, 'required|email') : null}</span>
//         </div>
//       </Col>
//     </Row>
//   </div>
//   );
// }

// export default Step2;


import React,{useContext} from "react";
import { Row, Col} from "react-bootstrap";
import CustomCheckboxTree from 'components/CheckboxTree/CheckboxTree';
import { useState, useEffect } from "react";
import { FetchAPI } from '../../api/fetch';
import ErrorFallback from "components/ErrorFallback/ErrorFallback";
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { WizardDataContext } from "context/WizardDataContext";
const cookies = new Cookies();

function Step2(props) { 
  const {setHasError} = props;
  const { t, i18n } = useTranslation();
  let [nodeValue, setnodeValue] = useState(props.block.nodes);
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  
  useEffect(() => {
   try{
    (async () => {
      
        if(props.futurename == 'Category'){
         // updateDropDwon(props.getDataURL, props.block.formValues);
        //  const getdrpdwnresponse = await FetchAPI(props.getDataURL);
         const getdrpdwnresponseJson = wizardData.productsDetail;

        //   if(getdrpdwnresponseJson.data.userInfo)
        setnodeValue(getdrpdwnresponseJson.data.data);
        if(getdrpdwnresponseJson.data.hasOwnProperty('assignedCategories') === true) {
          if(getdrpdwnresponseJson.data.assignedCategories !== null)
            props.setSelectChildValueCheckbox(getdrpdwnresponseJson.data.assignedCategories.split(','))
        }
      }else {
        // let getURL = props.dropDwnApi;
        // const getdrpdwnresponse = await FetchAPI(getURL);
        const getdrpdwnresponseJson = wizardData.productsView
        setnodeValue(getdrpdwnresponseJson.data.modules);
        //props.setSelectChildValueCheckbox([]);
      }
    // }
    })()
   }catch(error){
    setHasError({
      error: true,
      message: error
     })
   }
  }, [wizardData]);

  if (props.currentStep !== props.block.step) {
    return null
  }

  return(
  <div>
    <Row>
      <Col md="4" className="mb-3">
        <div className="custom-control custom-checkbox pl-3">
          <CustomCheckboxTree
            nodes={nodeValue}
            checked = {chk => props.checkboxcheck(chk)}
            expanded = {exp => props.checkboxexpand(exp)}
            selectChildValueCheckbox={props.selectChildValueCheckbox}
            selectChildValueCheckboxExpanded={props.selectChildValueCheckboxExpanded}
          />
              <span>{ (Object.keys(props.selectChildValueCheckbox).length == 0) ? 
                               props.validator.message(t('Minimum one Permission'), props.selectChildValueCheckbox, 'required|email') : null}</span>
        </div>
      </Col>
    </Row>
  </div>
  );
}

export default Step2;